// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__4f2D9","tyre":"style_tyre__MtW9s"};